import { Box, Heading, Text } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Glyph } from '~/components/glyph';
import { useI18n } from '~/hooks/use-i18n';

const JAPANESE_NO_RESULTS_MESSAGE =
  'この言語では検索結果が見つかりませんでした。より多くのプログラムを探すには、英語で検索してみてください。';

export function CatalogNoResults() {
  const { t, isJa } = useI18n();

  return (
    <Card
      alignItems='center'
      borderColor='accent.sky.500'
      display='flex'
      flexDirection='column'
      padding='40px'
      textAlign='center'
    >
      <Glyph name='browser-binary-magnifying-glass-one' />
      <Box h='16px' />
      <Heading as='h2' size='h4'>
        {t('catalog.noResults.heading')}
      </Heading>
      <Box h='8px' />
      {isJa ? <Text fontSize='sm'>{JAPANESE_NO_RESULTS_MESSAGE}</Text> : <Text>{t('catalog.noResults.body')}</Text>}
    </Card>
  );
}
